/** Past this many unread, both the bell badge and the panel's Unread tab read "99+". */
export const UNREAD_DISPLAY_CAP = 99;

/**
 * One cap for every place that shows the unread count. The bell and the panel
 * header used to cap differently ("99+" against "Unread · 100", the latter
 * being the notifications query's own page size), which read as two numbers.
 */
export const formatUnreadCount = (
  count: number,
  formatNumber: (value: number) => string = String,
): string =>
  count > UNREAD_DISPLAY_CAP ? `${formatNumber(UNREAD_DISPLAY_CAP)}+` : formatNumber(count);

interface ImpersonationSubject {
  impersonatedOrg: { name?: string } | null;
  impersonatedBrand: { name?: string } | null;
  impersonatedRole: 'admin' | 'vendor' | 'store' | null;
}

/** The account a View-as session is looking at, as the banner names it. */
export const impersonationSubjectName = (
  { impersonatedOrg, impersonatedBrand, impersonatedRole }: ImpersonationSubject,
  t: (key: string) => string,
): string =>
  impersonatedOrg?.name ||
  impersonatedBrand?.name ||
  (impersonatedRole ? t(`shell.role.${impersonatedRole}`) : '');
